var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16663 6.76224C2.16663 3.49622 4.76997 0.833374 7.99996 0.833374C11.23 0.833374 13.8333 3.49622 13.8333 6.76224C13.8333 8.33897 13.3839 10.032 12.5896 11.4946C11.7962 12.9555 10.637 14.2249 9.18697 14.9026C8.43367 15.2547 7.56625 15.2547 6.81295 14.9026C5.36287 14.2249 4.2037 12.9555 3.41033 11.4946C2.61598 10.032 2.16663 8.33897 2.16663 6.76224ZM7.99996 1.83337C5.33891 1.83337 3.16663 4.0317 3.16663 6.76224C3.16663 8.16028 3.56838 9.69031 4.2891 11.0174C5.01079 12.3462 6.03064 13.4331 7.23639 13.9967C7.72133 14.2234 8.27859 14.2234 8.76353 13.9967C9.96928 13.4331 10.9891 12.3462 11.7108 11.0174C12.4315 9.69031 12.8333 8.16028 12.8333 6.76224C12.8333 4.0317 10.661 1.83337 7.99996 1.83337ZM7.99996 5.16671C7.17153 5.16671 6.49996 5.83828 6.49996 6.66671C6.49996 7.49513 7.17153 8.16671 7.99996 8.16671C8.82839 8.16671 9.49996 7.49513 9.49996 6.66671C9.49996 5.83828 8.82839 5.16671 7.99996 5.16671ZM5.49996 6.66671C5.49996 5.286 6.61925 4.16671 7.99996 4.16671C9.38067 4.16671 10.5 5.286 10.5 6.66671C10.5 8.04742 9.38067 9.16671 7.99996 9.16671C6.61925 9.16671 5.49996 8.04742 5.49996 6.66671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.02d5c55c6daef622b598d7542e0e88e7.svg";
export { ForwardRef as ReactComponent };